<template>
  <div class="loginPage">
    <div class="pageAds" :style="bannerStyle">
      <img :src="logoSrc" alt="ws-logo" class="wsLogo" />
      <div class="mask"></div>
      <!--div class="adDesc">
        <div class="content">
          <div class="item">
            <label>主办单位</label>
            <div>广西教育学院</div>
          </div>

          <div class="item">
            <label>创刊时间</label>
            <div>2012年</div>
          </div>

          <div class="item">
            <label>编辑部地址</label>
            <div>广西南宁市建政路37号</div>
          </div>
        </div>

        <div class="content">

          <div class="item">
            <label>国内刊号</label>
            <div>45-1387/G4</div>
          </div>

          <div class="item">
            <label>国际刊号</label>
            <div>2095-3437</div>
          </div>

          <div class="item">
            <label>邮发代号</label>
            <div>48-21</div>
          </div>
        </div>
      </div-->
    </div>

    <div class="pageMain">
      <div class="formMain">
        <h3>{{kwmc}}投审稿系统</h3>

        <el-form size="large" ref="formData" :model="form">
          <el-row v-if="type == 1">
            <el-form-item prop="username" :rules="ruleAccountName">
              <el-input placeholder="账号" size="large" v-model="form.username"></el-input>
            </el-form-item>

            <el-form-item prop="password" :rules="ruleAccountPwd">
              <el-input placeholder="密码" size="large" v-model="form.password" :show-password="true"></el-input>
            </el-form-item>

            <el-form-item
              prop="captchaCode"
              :rules="{
                required: true,
                min: 4,
                max: 4,
                message: '请填写4位数的图形验证码',
                trigger: 'blur',
              }"
            >
              <el-row>
                <el-col :span="16">
                  <div>
                    <el-input ref="captchaCode" placeholder="图形验证码" size="large" v-model="form.captchaCode"></el-input>
                  </div>
                </el-col>

                <el-col :span="8">
                  <el-image :src="'data:image/png;base64,' + captchaSrc" style="height: 40px" alt="单击刷新验证码" @click="loadCaptcha"></el-image>
                </el-col>
              </el-row>
            </el-form-item>

            <div class="login-info">
              <router-link class="forgot" to="/forgetPwd">忘记密码</router-link>
            </div>

            <el-form-item style="margin-top: 40px">
              <el-button type="primary" size="large" style="width: 100%" @click="submit1">登录</el-button>
            </el-form-item>
          </el-row>
        </el-form>

        <el-form size="large" ref="formData2" :model="form2">
          <el-form-item v-if="type == 2" prop="phone" :rules="rulePhone">
            <el-input ref="phone" placeholder="手机号码" v-model="form2.phone" size="large"></el-input>
          </el-form-item>

          <el-form-item
            v-if="type == 2"
            prop="captchaCode2"
            :rules="{
              required: true,
              min: 4,
              max: 4,
              message: '请填写4位数的图形验证码',
              trigger: 'blur',
            }"
          >
            <el-row>
              <el-col :span="8">
                <div>
                  <el-input ref="captchaCode2" oninput="if(value.length>4)value=value.slice(0,4)" placeholder="图形验证码" size="large" v-model="form2.captchaCode2"></el-input>
                </div>
              </el-col>

              <el-col :span="9">
                <el-image :src="'data:image/png;base64,' + captchaSrc" style="height: 40px" alt="单击刷新验证码" @click="loadCaptcha"></el-image>
              </el-col>

              <el-col :span="7">
                <div style="padding-left: 10px">
                  <ButtonCountDown style="width: 100%" ref="ButtonCountDown" type="primary" size="large" text="发送短信" count="60" :method="sendSMS"></ButtonCountDown>
                </div>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item
            v-if="type == 2"
            prop="smsCode"
            :rules="{
              required: true,
              min: 4,
              max: 4,
              message: '请填写4位数的短信验证码',
              trigger: 'blur',
            }"
          >
            <el-row v-show="sendSMSed">
              <el-col :span="8">
                <div>
                  <el-input ref="smsCode" oninput="if(value.length>4)value=value.slice(0,4)" v-model="form2.smsCode" placeholder="短信验证码" size="large"></el-input>
                </div>
              </el-col>
              <el-col :span="16">
                <div style="margin-left: 15px">输入收到的4位数短信验证码</div>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item v-if="type == 2" style="margin-top: 40px">
            <el-button type="primary" size="large" style="width: 100%" @click="submit2">登录</el-button>
          </el-form-item>
        </el-form>

        <ul class="footer">
          <li>
            <span>没有账号？<router-link class="forgot" to="/register">注册</router-link></span>
          </li>
          <li v-if="type == 1">
            <a @click="type = 2">使用短信验证码登录</a>
          </li>
          <li v-if="type == 2">
            <a @click="type = 1">使用账号密码登录</a>
          </li>
        </ul>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{ dialogContent }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ButtonCountDown from "@/components/ButtonCountDown.vue"
import captchaApi from "@/api/captcha"
import accountApi from "@/api/account"
import systemApi from "@/api/system"
import { MessageBox } from 'element-ui';
import { validAccountName, validAccountPwd, validPhone } from "@/utils/valid"
export default {
  name: "Login",
  components: {
    ButtonCountDown,
  },
  data() {
    var validAccountNameFun = (rule, value, callback) => {
      if (!validAccountName(value)) {
        callback(new Error("长度在 6 到 20 个英文/下划线/数字，第一个字母不能是下划线和数字"))
      } else {
        callback()
      }
    }

    var validAccountPwdFun = (rule, value, callback) => {
      if (!validAccountPwd(value)) {
        callback(new Error("长度在 6 到 20 个字符(必须包含数字/小写字母/大写字母)"))
      } else {
        callback()
      }
    }

    var validPhoneFun = (rule, value, callback) => {
      if (!validPhone(value)) {
        callback(new Error("手机号码格式不正确"))
      } else {
        callback()
      }
    }
    return {
      kwmc:'测试期刊',
      type: 1,
      logoSrc: require('@/assets/logo_'+process.env.VUE_APP_PLATFORM+'.png'),
      bannerStyle: {
        backgroundImage: "url(" + require("@/assets/auth_banner_"+process.env.VUE_APP_PLATFORM+".jpg") + ")",
      },
      dialogType: "",
      dialogVisible: false,
      dialogContent: "",
      captchaSrc: "",
      form: {
        captchaCode: "",
        captchaCodeKey: "",
        password: "",
        username: "",
      },
      sendSMSed: false,
      form2: {
        phone: "",
        captchaCode2: "",
        smsCode: "",
      },
      ruleAccountName: [
        {
          required: true,
          min: 6,
          max: 20,
          message: "长度在 6 到 20 个英文/下划线/数字，第一个字母不能是下划线和数字",
          trigger: "blur",
        },
        { validator: validAccountNameFun, trigger: "blur" },
      ],

      ruleAccountPwd: [
        {
          required: true,
          min: 6,
          max: 20,
          message: "长度在 6 到 20 个字符(必须包含数字/小写字母/大写字母)",
          trigger: "blur",
        },
        { validator: validAccountPwdFun, trigger: "blur" },
      ],

      rulePhone: [
        {
          required: true,
          trigger: "blur",
          message: "手机号码必须填写",
        },
        { validator: validPhoneFun, trigger: "blur" },
      ],
    }
  },

  created() {
    if(process.env.VUE_APP_PLATFORM=='dx'){
      this.kwmc='大学教育';
    }else if(process.env.VUE_APP_PLATFORM=='zx'){
      this.kwmc='中学教学参考';
    }else if(process.env.VUE_APP_PLATFORM=='xx'){
      this.kwmc='小学教学参考';
    }
    this.checkBroswer()
    this.initSetting()
    this.loadCaptcha()
  },

  methods: {
    checkBroswer() {
      //取得浏览器的userAgent字符串
      /**
       * 360安全浏览器13-极速版，版本号：13.1.6020.0|内核版本：86.0.4240.198
       * Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/86.0.4240.198 Safari/537.36
       * 360安全浏览器13-兼容模式，版本号：13.1.6020.0|内核版本：86.0.4240.198
       * Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729; rv:11.0) like Gecko
       * --------------------------------------------------------------
       * 360极速浏览器-极速版，版本号：13.5.2022.0|内核版本：86.0.4240.198
       * Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/86.0.4240.198 Safari/537.36
       * 360极速浏览器-兼容模式，版本号：13.5.2022.0|内核版本：86.0.4240.198
       * Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729; rv:11.0) like Gecko
       * --------------------------------------------------------------
       * Microsoft IE
       * Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729; rv:11.0) like Gecko
       * Microsoft Edge
       * Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/103.0.5060.53 Safari/537.36 Edg/103.0.1264.37
       * --------------------------------------------------------------
       * Google Chrome
       * Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/101.0.0.0 Safari/537.36
       * Firefox
       * Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:101.0) Gecko/20100101 Firefox/101.0
       * --------------------------------------------------------------
       * QQBrowser
       * Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/77.0.3865.120 Safari/537.36 Core/1.77.119.400 QQBrowser/10.9.4817.400
       *----------------------------------------------------------------
       * Iphone
       * Mozilla/5.0 (iPhone; CPU iPhone OS 13_2_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Mobile/15E148 Safari/604.1
       * 
       
       */
      var userAgent = window.navigator.userAgent;
      var isFirefox = userAgent.indexOf("Firefox") > -1
      var isChrome = userAgent.indexOf("Chrome") > -1
      var isSafari = userAgent.indexOf("Safari") > -1
      var isGecko = userAgent.indexOf("Gecko") > -1
      if (!isFirefox && (isGecko && !isChrome) && !isSafari) {
        MessageBox.alert("<div style='padding:7px 0;color:#FF2200;'>系统不支持IE内核，请勿使用IE、360浏览器兼容模式、QQ浏览器兼容模式等!</div><h3>推荐使用以下浏览器</h3><ul style='list-style-type:circle; padding-left:15px;'><li>谷歌浏览器</li><li>火狐浏览器</li><li>微软Edge浏览器</li><li>360浏览器极速模式</li></ul>", "系统警告", {
          dangerouslyUseHTMLString:true,
          showClose:false,
          showConfirmButton:false,
          confirmButtonText: "确定",
          callback: () => {},
        })
      }

      console.log(process.env.VUE_APP_PLATFORM);
    },

    dialogOpen(type, content) {
      this.dialogType = type
      this.dialogContent = content
      this.dialogVisible = true
    },
    initSetting() {
      systemApi.getName().then((res) => {
        this.$store.commit("app/SET_SYSNAME", res.data)
        this.sysName = res.data
      })
    },
    dialogClose() {
      if (this.dialogType == "phone") {
        this.$refs["phone"].focus()
      } else if (this.dialogType == "captchaCode") {
        this.$refs["captchaCode"].focus()
      } else if (this.dialogType == "captchaCode2") {
        this.$refs["captchaCode2"].focus()
      } else if (this.dialogType == "smsCode") {
        this.$refs["smsCode"].focus()
      }
      this.dialogType = null
      this.dialogVisible = false
    },
    loadCaptcha() {
      captchaApi.image("char").then((res) => {
        if (res.code == 0) {
          this.captchaSrc = res.data.img
          this.form.captchaCodeKey = res.data.key
        }
      })
    },

    sendSMS() {
      Promise.all(
        ["phone", "captchaCode2"].map((item) => {
          return new Promise((resolve) => {
            this.$refs.formData2.validateField(item, (error) => {
              resolve(error)
            })
          })
        })
      ).then((data) => {
        if (data.length <= 0 || (data[0] == "" && data[1] == "")) {
          this.$refs.ButtonCountDown.start()
          accountApi.sendSMSForLogin(this.form2.phone, this.form2.captchaCode2, this.form.captchaCodeKey).then((res) => {
            if (res.code == 0) {
              this.sendSMSed = true
              this.dialogOpen("smsCode", "短信验证码已经发送到手机上，请注意查看")
            } else {
              this.$refs.ButtonCountDown.stop()
              this.dialogOpen("", "发送短信失败，" + res.msg)
            }
          })
        }
      })
    },

    submit1() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          accountApi.loginByAccount(this.form).then((res) => {
            if (res.code == 0) {
              this.$store.commit("user/SET_TOKEN", res.data)
              this.$router.push("/")
            } else if (res.code == 1) {
              this.dialogOpen("", res.msg)
            }
          })
        }
      })
    },

    submit2() {
      Promise.all(
        ["phone", "smsCode"].map((item) => {
          return new Promise((resolve) => {
            this.$refs.formData2.validateField(item, (error) => {
              resolve(error)
            })
          })
        })
      ).then((data) => {
        if (data.length <= 0 || (data[0] == "" && data[1] == "")) {
          accountApi.loginByMobile(this.form2.phone, this.form2.smsCode).then((res) => {
            if (res.code == 0) {
              this.$store.commit("user/SET_TOKEN", res.data)
              this.$router.push("/")
            } else if (res.code == 1) {
              this.dialogOpen("", res.msg)
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
h3 {
  margin-bottom: 50px;
  font-size: 24px;
  color: rgb(0, 0, 0);
  font-weight: 700;
}
.loginPage {
  display: flex;
  width: 100vw;
  flex-direction: row;

  .pageAds {
    background-color: black;
    position: relative;
    width: 0;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }

  .wsLogo {
    margin: 40px;
  }

  .pageMain {
    flex: 1;
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width:100%;
  }

  .formMain {
    /*width: 400px;*/
  }
}

@media screen and (min-width: 768px) {
  .loginPage .pageAds {
    width: 40%;
  }
}

@media screen and (min-width: 992px) {
  .loginPage .pageAds {
    width: 50%;
  }
}

@media screen and (min-width: 1200px) {
  .loginPage .pageAds {
    width: 60%;
  }
}

@media screen and (min-width: 1920px) {
  .loginPage .pageAds {
    width: 65%;
  }
}

.pageAds .mask {
  background-image: linear-gradient(179deg, rgba(20, 21, 22, 0) 0%, rgba(20, 21, 22, 0.07) 21%, rgb(43, 51, 65) 97%);
  height: 600px;
  width: 100%;
  position: absolute;
  bottom: 0px;
}

.pageAds .adDesc {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  width: 100%;
  position: absolute;
  bottom: 40px;
}

.adDesc .content {
  display: flex;
  flex-direction: row;
}

.adDesc .item {
  flex: 1;
  display: flex;
  flex-direction: row;
}
.adDesc .item label {
  width: 120px;
  text-align: right;
  margin-right: 15px;
}
.adDesc .item div {
  flex: 1;
}

.login-info {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  margin: 8px 0px 34px;

  color: rgb(65, 80, 88);
  font-size: 14px;

  .forgot {
    text-align: end;
    display: inline-block;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.48);
    margin-left: auto;
    cursor: pointer;
  }
}

.footer {
  -webkit-box-flex: 0.9;
  flex-grow: 0.9;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  font-size: 14px;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  margin-bottom: auto;
}

.footer > li {
  margin-top: 16px;
}

.footer a {
  cursor: pointer;
  color: rgb(0, 123, 255);
}
</style>
